import React from "react";
import { Container } from "react-bootstrap";
import classes from './linkBlock.module.css';
import LinkBlock from "./linkBlock";

const LinkList = ({blocks, logo, title }) => {
    return (
        <Container fluid="md">
            <h1 className={classes.h1Title}>{title}</h1>
            <div className={classes.linkBox}>
                {blocks.map((block, index) =>
                    <LinkBlock number={index +1} block={block} key={block.id} logo={logo} />
                )}
            </div>
        </Container>
    )
}

export default LinkList;